import ResourceTyped from 'App/babel/resources/ResourceTyped';
import { AISummaryMeetingDebrief } from './Model/AISummary';
import type AISummary from './Model/AISummary';

class AISummaryResource extends ResourceTyped<AISummary> {
	constructor() {
		super('aISummaries');
	}

	getByEntityAndType(entity: string, type: string, entityId: number): Promise<AISummary | null> {
		return super._getRequest(`${entity}/${type}/${entityId}`, {}).then((res: any) => res?.data?.data ?? null);
	}

	getMeetingDebriefInternal(appointmentId: number): Promise<AISummaryMeetingDebrief | null> {
		return this.getByEntityAndType('appointment', 'meeting_summary_internal', appointmentId) as Promise<AISummaryMeetingDebrief | null>;
	}
}

export default new AISummaryResource();

